export default "__VITE_ASSET__DnXS1bMF__"